import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import UserStatStateSlice, { UserStat } from "../../../models/state/userStats";
import * as metaSelectors from "./meta";
import * as statSelectors from "./stat";
import { UserStatsMetaSelectors, UserStatsStatSelectors } from "./types";

type State = UserStatStateSlice;

function getStats(state: State): UserStat {
  return state.stats;
}

function getMeta(state: State) {
  return state.meta;
}

// @ts-ignore
export const {
  getTotalStudyTime,
  getSessionsCompleted,
  getUserLastStudied,
  getSessionModulesStudied,
  getSessionModulesCorrect,
  getUserRecentlyStudiedCourses,
  getRecentlyStudiedCourseIds
}: UserStatsStatSelectors<State> = composeSelectors(getStats, statSelectors);

// @ts-ignore
export const {
  userStatsFetching,
  userStatsFetchSucceeded,
  userStatsFetchErrored,
  userStatsFetchFinished,
  userStatsNeedsFetching
}: // @ts-ignore
UserStatsMetaSelectors<State> = composeSelectors(getMeta, metaSelectors);
